import { createSlice, Dictionary } from '@reduxjs/toolkit';
import { ISystemUserAccount } from 'api/models/account.model';
import SystemUser from 'api/models/systemUser.model';
import { LoadingStatus } from 'interfaces/loadingStatus';
import { usersExtraReducers, usersReducers } from './user-identities.reducers';

const initialState: UsersState = {
    data: {},
    userIdsLoading: [],
    loading: LoadingStatus.Idle,
};

const userIdentities = createSlice({
    name: 'user-identities',
    initialState,
    reducers: {
        ...usersReducers,
    },
    extraReducers: (builder) => {
        usersExtraReducers(builder);
    },
});

export const { cleanupUserIdentitiesData, setUsersLoading } = userIdentities.actions;

export default userIdentities.reducer;

export type UsersState = {
    data: Dictionary<ISystemUserAccount | SystemUser>;
    userIdsLoading: string[];
    loading: LoadingStatus;
};
